"use client"

import { Box, IconButton, Slide, Tooltip } from "@mui/material"
import { scrollToTop } from "@v2/helpers/dom"
import useScrollYChange from "@v2/hooks/useScrollYChange"
import { ArrowUp } from "lucide-react"
import { usePathname } from "next/navigation"
import { useCallback, useEffect, useRef, useState } from "react"

export default function BackToTop() {
    const pathname = usePathname()
    const [visible, setVisible] = useState(false)
    const previousScrollYRef = useRef<number | null>(null)
    const isProductPage = /^\/fa(?:\/v2)?\/products\/[^/]+\/?$/.test(pathname)
    const updateVisibility = useCallback((scrollY: number) => {
        const previousScrollY = previousScrollYRef.current
        previousScrollYRef.current = scrollY
        if (previousScrollY === null) return;

        if (scrollY < previousScrollY - 4) {
            setVisible(scrollY > window.innerHeight)
        } else if (scrollY > previousScrollY + 4) {
            setVisible(false)
        }
    }, [])

    useScrollYChange(updateVisibility, [], { ttl: 100 })

    useEffect(() => {
        previousScrollYRef.current = window.scrollY
    }, [])

    return (
        <Slide direction="up" in={visible} mountOnEnter unmountOnExit>
            <Box sx={{
                position: 'fixed',
                left: { xs: 24, sm: 24 }, // flipped by the RTL plugin: shows on the right
                bottom: { xs: isProductPage ? 80 : 24, sm: 24, md: 48 },
                zIndex: 80,
            }}>
                <Tooltip title="بازگشت به بالا" placement="left">
                    <IconButton
                        aria-label="بازگشت به بالای صفحه"
                        onClick={scrollToTop}
                        sx={{
                            width: { xs: 44, sm: 48, md: 56 },
                            height: { xs: 44, sm: 48, md: 56 },
                            bgcolor: '#fff',
                            border: '1px solid',
                            borderColor: 'grey.300',
                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.16)',
                            '&:hover': {
                                bgcolor: 'grey.100',
                            },
                            '& svg': {
                                width: { xs: 20, md: 24 },
                                height: { xs: 20, md: 24 },
                            },
                        }}
                    >
                        <ArrowUp />
                    </IconButton>
                </Tooltip>
            </Box>
        </Slide>
    )
}
